/**
 * @desc 财务画像-基础信息-资产负债构成
 */
import React from 'react';
import style from './assetLiabilities.scss';
import NoData from '../../../common/noData/NoData';
import BBDPie from '../../../common/echarts/BBDPie';
import { Spin } from 'antd';
import { isNotEmpty } from '../../../../utils/util';
import { commonPieOption } from '../../common/commons';

export default function AssetLiabPie({ pieData, loading }) {
    let color = [
            '#F8B551', '#F99248', '#73CDFC',
            '#90BBF8', '#2365C4', '#534FCF',
            '#AAA7F9', '#ACD598', '#6CBA52',
            '#097C25', '#ED726C'
        ],
        center = ['40%', '48%'],
        legend = {
            type: 'scroll',
            height: 158,
            left: '66%'
        };

    return (
        <div className={style.content}>
            {loading ? <Spin /> :
                isNotEmpty(pieData) ?
                    <div className={style.degreePie}>
                        <BBDPie option={commonPieOption(legend, center, color, pieData)} />
                </div> : <NoData />
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/AssetLiabPie.jsx